import React, { lazy, Suspense } from 'react';
import './app/layouts/steam/steamPagePlaceholder';
import SteamPageNew from './app/layouts/steam/steamPageNew';
import SteamShop from './app/layouts/steam/steamShop';
import PlayStationShop from './app/layouts/playStation/playStationShop';
import MainPage from './app/layouts/mainPage';
import NintendoDiscount from './app/layouts/nintendo/nintendoDiscount';
import SteamDiscount from './app/layouts/steam/steamDiscount';
import PlayStationDiscount from './app/layouts/playStation/playStationDiscount';
import NintendoShop from './app/layouts/nintendo/nintendoShop';
import PaymentSuccess from './app/layouts/payment/paymentSuccess';
import PaymentFail from './app/layouts/payment/paymentFail';
import { Navigate } from 'react-router-dom';
import CookiesInfoPage from './app/layouts/cookiesInfoPage';
import OfferPage from './app/layouts/offerPage';
import PrivacyPage from './app/layouts/privacyPage';
import ConsentPage from './app/layouts/consentPage';
import OtherStorePage from './app/visoria/pages/OtherStorePage';
import OtherStoreOrderPage from './app/visoria/pages/OtherStoreOrderPage';
import NotFoundPage from './app/pages/notFoundPage';
import AccountPage from './app/account/AccountPage';
import AccountOrderPage from './app/account/AccountOrderPage';

/** Админка не в основном чанке витрины — грузится только по /vs-ops/*. */
const VsOpsLoginPage = lazy(() => import('./app/vs-ops/VsOpsLoginPage'));
const VsOpsSalesPage = lazy(() => import('./app/vs-ops/VsOpsSalesPage'));
const VsOpsStatsPage = lazy(() => import('./app/vs-ops/VsOpsStatsPage'));
const VsOpsSettingsPage = lazy(() => import('./app/vs-ops/VsOpsSettingsPage'));
const VsOpsWarehousePage = lazy(() => import('./app/vs-ops/VsOpsWarehousePage'));
const VsOpsReferralsPage = lazy(() => import('./app/vs-ops/VsOpsReferralsPage'));

function vsOpsPage(Page) {
  return (
    <Suspense fallback={<div className="p-8 text-center text-sm text-gray-500">Загрузка…</div>}>
      <Page />
    </Suspense>
  );
}

export const routes = [
   { path: "/", element: <MainPage />, display: false, title: "Главная" },
   { path: "/nintendo-eshop", element: <Navigate to={"/nintendo-eshop/shop"} />, display: false, title: "Магазин Nintendo" },
   { path: "/nintendo-eshop/shop", element: <NintendoShop />, display: true, title: "Магазин Nintendo", group: "nintendo", shortName: "Магазин" },
   { path: "/nintendo-discount", element: <NintendoDiscount />, display: true, title: "Скидки Nintendo", group: "nintendo", shortName: "Скидки" },
  { path: "/steam/topup", element: <SteamPageNew />, display: true, title: "Пополнение Steam", group: "steam", shortName: "Пополнение"},
  { path: "/steam", element: <Navigate to={"/steam/topup"} replace />, display: false, title: "Пополнение Steam" },
  { path: "/steam/shop", element: <SteamShop />, display: true, title: "Магазин Steam", group: "steam", shortName: "Магазин" },
  { path: "/steam-new", element: <Navigate to={"/steam/topup"} replace />, display: false, title: "Пополнение Steam" },
   { path: "/steam-discount", element: <SteamDiscount />, display: true, title: "Скидки Steam", group: "steam", shortName: "Скидки" },
   { path: "/playstation", element: <Navigate to={"/playstation/shop"} />, display: false, title: "Магазин PlayStation" },
   { path: "/playstation/shop", element: <PlayStationShop />, display: true, title: "Магазин PlayStation", group: "playstation", shortName: "Магазин" },
   { path: "/playstation-discount", element: <PlayStationDiscount />, display: true, title: "Скидки PlayStation", group: "playstation", shortName: "Скидки" },
   { path: "/steam/payment-success", element: <PaymentSuccess />, display: false, title: "Платеж успешен" },
   { path: "/steam/payment-fail", element: <PaymentFail />, display: false, title: "Ошибка платежа" },
   { path: "/cookies-info", element: <CookiesInfoPage />, display: false, title: "Мы используем cookie" },
   { path: "/offer", element: <OfferPage />, display: false, title: "Договор публичной оферты" },
   { path: "/privacy", element: <PrivacyPage />, display: false, title: "Политика обработки персональных данных" },
   { path: "/consent", element: <ConsentPage />, display: false, title: "Согласие на обработку персональных данных" },
   { path: "/account", element: <AccountPage />, display: false, title: "Личный кабинет" },
   { path: "/account/orders/:shop/:billId", element: <AccountOrderPage />, display: false, title: "Заказ" },
   { path: "/store/order/:orderId", element: <OtherStoreOrderPage />, display: false, title: "Заказ" },
   { path: "/store/:storeId", element: <OtherStorePage />, display: false, title: "Магазин" },
   { path: "/vs-ops/login", element: vsOpsPage(VsOpsLoginPage), display: false, title: "Visoria Ops" },
   { path: "/vs-ops", element: <Navigate to={"/vs-ops/sales"} />, display: false, title: "Visoria Ops" },
   { path: "/vs-ops/sales", element: vsOpsPage(VsOpsSalesPage), display: false, title: "Продажи" },
   { path: "/vs-ops/stats", element: vsOpsPage(VsOpsStatsPage), display: false, title: "Обороты" },
   { path: "/vs-ops/warehouse", element: vsOpsPage(VsOpsWarehousePage), display: false, title: "Склад" },
   { path: "/vs-ops/referrals", element: vsOpsPage(VsOpsReferralsPage), display: false, title: "Рефералка" },
   { path: "/vs-ops/settings", element: vsOpsPage(VsOpsSettingsPage), display: false, title: "Настройки" },
   { path: "*", element: <NotFoundPage />, display: false },
]
